// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import OrdersAvailableToShipTable from './components/orders-available-to-ship-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFamilies } from '../../common/repositories';
import { getOrdersAvailableToShip } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class OrdersAvailableToShip extends Component {

    state = {
        familyTypes: [],
        selectedFamilyType: 'ALL_FAMILIES',
        results: []
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getFamilies().then( response => {

            this.setState( {
                familyTypes: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );
        this.refresh();

    }

    handleTypeChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    refresh ( ) {

        this.props.increaseCounter();
        getOrdersAvailableToShip( this.state.selectedFamilyType )
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            selectedFamilyType, familyTypes, results
        } = this.state;

        const additionalInfo = ( results !== null ? {
            unitName: this.props.unit.name
        } : '' );
        const ordersShipToResult = results.map( i => ( { ...i, ...additionalInfo } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Orders Available To Ship</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-order-available-to-ship-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-order-available-to-ship-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={familyTypes}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyType}
                                />
                                {( selectedFamilyType || ( results.length > 0 ) ) && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                            </div>
                        </div>
                        {( selectedFamilyType || ( results.length > 0 ) ) && (
                            <OrdersAvailableToShipTable
                                results={ordersShipToResult}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

OrdersAvailableToShip.displayName = 'OrdersAvailableToShip';
OrdersAvailableToShip.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( OrdersAvailableToShip ) );
